import {
  AfterViewInit,
  Directive,
  EventEmitter,
  Input,
  Output,
  computed,
  effect,
  input,
  model,
  signal
} from '@angular/core';
import { CheckBoxItem } from '../components/inputs/checkbox-button/checkbox-button.component';
import _ from 'lodash';
import {  produce } from 'immer';
import { SelectAllFormFieldsDirective } from './selectAllFormFields/select-all-form-fields.directive';
import { signalState } from '@ngrx/signals';

export type FormFieldValue = string | string[] | Date |  null | boolean | undefined | {[value: string] : boolean};

export type FormContainerVM = {
  [name: string] : FormFieldValue
}

export type FormModel = {
  [name: string] : FormModel | FormFieldValue
}

@Directive({
  selector: '[formVMContainer]'
})
export class FormVMContainerDirective extends SelectAllFormFieldsDirective  implements AfterViewInit  {

  @Output() formValueChange  = new EventEmitter<FormModel>()

  formValue = input<FormModel>()

  twoWayModel = model<FormModel>()

  readonly state = signalState<FormModel>({});


  changeModelOnInputEf = effect( () => {
    const formVal = this.formValue()
    if (formVal == undefined) {
      return
    }
    const all = this.allChildrenFields();
    all.forEach( field => {
      const valueToSave = _.get(formVal , field.formPath() , undefined)
      const currentVal = field.model
      if (valueToSave == undefined) {
        return
      }
      if (currentVal == valueToSave) {
        return
      }
      if (currentVal && !valueToSave && field.type == 'radio') {
        return
      }
      // console.log({
      //   currentVal,
      //   valueToSave,
      //   path : field.formPath()
      // })
      field.model = valueToSave;
    })
    // console.log({formValue: this.formValue()})
  } , {allowSignalWrites: true})

  allFieldsInfo = computed(() => {
    return this.allChildrenFields().filter( f => f.name !== '_pass' ).map( f => f.fieldInfoForFormContainer() )
  })

  syncFieldsWithSamePathEf = effect( () => {
    const radios = this.radios()
    const models = radios.map( f => f.fieldInfoForFormContainer() ).filter( ({model}) => model != undefined )

    models.forEach( modelWithValue =>  {
      const radiosOfThisModel = radios
        .filter( radio => {
          const samePath = radio.formPathString() == modelWithValue.pathS;
          const diffValue = radio.value !== modelWithValue.value;
          const unchecked = !radio.nativeInputChecked();
          if (samePath && (radio.value || modelWithValue.value)) {
            // console.log( ({
            //   [radio.name] : {
            //     samePath, diffValue , unchecked
            //   }
            // }) )
          }
          return samePath && diffValue && unchecked
            // diffValue &&
            // unchecked
      })



      // console.log(radiosOfThisModel.map( f => ({
      //   fieldModel : f.model,
      //   value: f.value,
      //   modelModel : modelWithValue.model,
      //   modelValue : modelWithValue.value,

      // })))


      radiosOfThisModel.forEach( radioToSync => {
        radioToSync.model = undefined
      })

      // console.log(radiosOfThisModel.map( f => `${f.model}:${f.value}` ))


    })
  }, {allowSignalWrites: true})


  modelFromFields = computed(() => {
    const allFieldsModelInfo = this.allFieldsInfo();

    return _.reduce(
      allFieldsModelInfo ,
      (accumulatedState, currItem) =>
        produce( accumulatedState , (stateToEdit) => {
          if (currItem.model == undefined) {
            return
          }
          // if (currItem.type == 'check') {
          //   // _.set(stateToEdit, [...currItem.path , `${currItem.value}` ] , currItem.model)
          //   const prev = _.get(stateToEdit , [...currItem.path , currItem.value as string] ,  false )
          //   const toSet = !!currItem.model;
          //   console.log({prev, toSet , name : currItem.name + '.' + currItem.value})
          //   // if (prev == toSet) {
          //   //   return
          //   // }
          //   // _.set(stateToEdit, [...currItem.path , currItem.value as string] , currItem.model)
          //   return
          // }
            _.set(stateToEdit, currItem.path , currItem.model)
        }
        ),
      {} as FormModel )
  } , {equal: _.isEqual } )

  /**
   * tenta usar transformação em fields pra checkboxes
   */
  model2FromFields = computed(() => {
    const allFieldsModelInfo = this.allFieldsInfo();

    return _.reduce(
      allFieldsModelInfo ,
      (accumulatedState, currItem) =>
        produce( accumulatedState , (stateToEdit) => {
          if (currItem.model == undefined) {
            return
          }
          if (currItem.type == 'check') {
            const checkValuesModel = _.get(accumulatedState , currItem.pathRaw , []) as string[]
            const newCheckValues = currItem.model ?
              _.uniq([...checkValuesModel , currItem.value]) :
              checkValuesModel.filter( values => values !== currItem.value )
            _.set(stateToEdit, currItem.pathRaw , newCheckValues)
            return
          }
          _.set(stateToEdit, currItem.path , currItem.model)
        }
        ),
      {} as FormModel )
  } , {equal: _.isEqual } )

  // logEf = effect( () => {
  //   const model1 = this.modelFromFields()
  //   console.log(model1)
  // })

  // log2Ef = effect( () => {
  //   const model2 = this.model2FromFields()
  //   console.log(model2)
  // })


  emitEffect = effect( () => {
    this.formValueChange.emit(this.model2FromFields())
  })

  // fieldsToModelChangeEff = effect( () => {
  //   const internalModelFromFields = this.modelFromFields()
  //   this.internalModel.set({
  //     model: internalModelFromFields,
  //     lastWritter: 'fields->model'
  //   })

  // } , {allowSignalWrites: true})

  // modelToFieldChangeEff = effect( () => {
  //   const {model , lastWritter} = this.internalModel();
  //   if (lastWritter == 'fields->model') {
  //     return;
  //   }
  //   const all = this.allChildrenFields();
  //   all.forEach(  field => {
  //     const fieldModel = field.modelSig() ?? undefined;
  //     const internalModel = _.get( model , field.formPath() , undefined )
  //     if ( fieldModel === internalModel) {
  //       return
  //     }
  //     field.model = internalModel
  //   })
  //   this.internalModel.update( ({model}) => ({model , lastWritter: 'model->fields'}) )
  // }, {allowSignalWrites: true})


  // updateTwoWayMdodelEf = effect( () => {
  //   const modelFromFields = this.modelFromFields();
  //   this.model.set( modelFromFields)
  // } , {allowSignalWrites: true})


  // modelUpdateFieldsEffect = effect( () => {
  //   const modelTwoWay = this.model();
  //   const allFieldsInfo = untracked(this.allChildrenFields)
  //   allFieldsInfo.forEach( field => {
  //     const path = untracked(field.formPath)
  //     const toUpdate = _.get( modelTwoWay , path , undefined  )
  //     if (toUpdate == undefined) {
  //       return
  //     }
  //     field.model = toUpdate
  //   })

  // } , {allowSignalWrites: true})


  disableAllSig = signal(false)
  @Input() set disableAll(v : boolean){
    this.disableAllSig.set(v);
  } ;
  get diableAll() {
    return this.disableAllSig()
  }


  // public disableAllSig = toSignal(this._allDisabledObs)

  public containerModel = signal<FormContainerVM | null>(null ,
    {
      equal: (formA , formB) =>  _.isEqual(formA, formB)
    });

  checkBoxDicts : Record<string , CheckBoxItem[] > = {}

  ngAfterViewInit() {
    this.allChildrenFields().forEach( field => {
      field.formVMContainer = this;
    })
  }

}
